/**
 * This component is to be updated with props
 * for now we just return static content.
 */
import React from 'react';

const BudgetAreaTable = ({ data }) => {
  const {
    headings,
    rows
  } = data;

  return (
    <table className="c-info-block__table">
    <thead>
      <tr>
        {
          headings.map(heading => (
            <th key={heading.slug}>{heading.label}</th>
          ))
        }
      </tr>
    </thead>
    <tbody>
      {
        rows.map((row, index) => (
          <tr key={index}>
            {
              Object.keys(row).map(key => (
                <td key={key}>{row[key]}</td>
              ))
            }
          </tr>
        ))
      }
    </tbody>
  </table>
  )
}

export default BudgetAreaTable;



// WEBPACK FOOTER //
// ./src/components/common/tables/BudgetAreaTable.jsx